module.exports = __webpack_public_path__ + "img/close-button.ab213d57.svg";